import { createSelector } from 'reselect';
import { CustomerSelectors } from 'invision-core';
export var CustomerAccountStatusSelector = createSelector([CustomerSelectors.SelectedCustomerSelector], function (selectedCustomer) {
  if (selectedCustomer.accountStatus) {
    return selectedCustomer.accountStatus.data;
  } else {
    return null;
  }
});
export var IsFetchingAccountStatusDataSelector = createSelector([CustomerSelectors.SelectedCustomerSelector], function (selectedCustomer) {
  if (selectedCustomer.accountStatus) {
    return selectedCustomer.accountStatus.isFetchingData;
  } else {
    return false;
  }
});
export var ShowCustomerAutoPayBannerSelector = createSelector([CustomerSelectors.SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.accountStatus.showAutoPayBanner;
});